import { createSlice } from "@reduxjs/toolkit"
import { toast } from "react-toastify";
import apiService from "../../api/ApiService";
const initialState={
    currentWarnStatus:'',
    currentWarings:[],
    loading:false,
}

const warningSlice=createSlice({
name:'warnings',

initialState,
reducers:{
  
 
   
    AddStatus:(state,{payload})=>{
        state.currentWarings=payload
    },
    deleteWarn:(state)=>{
        state.currentWarnStatus=''
    }
    
    
    

}
})
export const {deleteWarn,AddStatus}=warningSlice.actions

export default warningSlice.reducer